import React from 'react'
import classNames from 'classnames'
import { SliderPaginationProps } from './SliderPagination.d'

const SliderPagination = ({
  pagination = 'none',
  classes = ''
}: SliderPaginationProps) => {
  if (pagination === 'none') return null
  const paginationClasses = classNames(
    'swiper-pagination mt-4 !relative z-auto',
    classes,
    {
      'bullets-blue-75': pagination === 'slide-pag-blue-75'
    }
  )
  return <div className={paginationClasses} data-testid='SliderPagination' />
}

export default SliderPagination
